export function filterNomeInput(value: string): string {
  return value.normalize("NFC").replace(/[^\p{L}\p{M} ]/gu, "");
}

export function isNomeValido(value: string): boolean {
  return /^(?:\p{L}\p{M}*)+(?: +(?:\p{L}\p{M}*)+)*$/u.test(value.trim().normalize("NFC"));
}

export function nomePessoaChave(value: string): string {
  return value.trim().normalize("NFD").replace(/\p{M}/gu, "").toLocaleLowerCase("pt-BR");
}
